{
  "(optional)": "(opcional)",
  "(required)": "(necesario)"
}
